/* Copyright (c) 2020-present CloudIO Inc */

import { toOptions } from 'componentregistry/utils/ManagerUtils';
import { Platform } from '../../platform/Platform';
import { ComponentManagerFn } from '../../registry/Component.type';
import { ItemType } from '../../registry/ComponentRegistry';
import { baseComponentManager } from '../../registry/Components';
import { defaultValue } from './SimpleFilter';

const SimpleFilterManager: ComponentManagerFn<'SimpleFilter'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'SimpleFilter'>(platform, 'SimpleFilter'),
    type: 'SimpleFilter',
    name: 'Quick Filter',
    isChildAllowed: (page, item, childType) =>
      (['SimpleFilterAttribute'] as ItemType[]).includes(childType),
    defaultValue,
    defaultChildren: ['SimpleFilterAttribute'],
    props: {
      filterType: {
        label: 'Filter Type',
        options: toOptions(['local', 'remote']),
        type: 'select',
        helpText:
          'Use the Remote option to re-query the store whenever the filter is changed. Otherwise, it will be applied to store data in memory.',
      },
      placeholder: {
        label: 'Placeholder',
        type: 'string',
      },
      showBorder: {
        label: 'Show Border',
        type: 'boolean',
      },
      roundedCorners: {
        label: 'Rounded Corners',
        type: 'boolean',
      },
    },
    isPropertyVisible: (property, itemData) => {
      switch (property) {
        case 'roundedCorners':
          return itemData.showBorder;
        default:
          return true;
      }
    },
    category: 'Data',
    icon: { iconName: 'filter' },
    excludeChildren: true,
    description: `A simple filter that can be used to filter the store data using multiple attributes.

\`\`\`alert
If the Filter Type is set to Local and if the store is not already queried, a blind query will be issued to fetch all data from the server.
\`\`\`
`,
  };
};

export default SimpleFilterManager;
